import { api } from '@/service/http';

export const aiTreeVirtualStore = async (api_url, loadOptions, treeListData) => {
    const result = await api(api_url, { ...loadOptions, rootCount: treeListData.rootCount });
    if (result.err) {
        return { data: [], rootCount: 0, totalCount: 0 };
    }
    return { data: treeListData.data.concat(result.data), rootCount: 0, totalCount: 0 };
};
